export default {
  off: {
    en: 'off',
  },
}
